import { gql } from '@apollo/client'

export const GetBulkActionStatus = gql`
    query getBulkProductListingDetailStatus(
        $input: GetBackendProcessStatusInput!
    ) {
        getBulkProductListingDetailStatus(input: $input) {
            errorMessage
            progressPercentage
            state
            result {
                bulkAction
                failedBulkProductDetailTransaction {
                    failureReason
                    productName
                }
            }
        }
    }
`
